import axios from "axios";
import {KEY_STRING} from "./consts";

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error('Lỗi khi đọc file'));
    reader.readAsDataURL(blob);
  });
}

export const createXHR = (): XMLHttpRequest => {
  // ActiveXObject is not present in standard TS libs; cast when needed for legacy support
  if ((window as any).XMLHttpRequest) {
    return new XMLHttpRequest();
  } else {
    // legacy IE fallback (kept for compatibility)
    return new (window as any).ActiveXObject("Microsoft.XMLHTTP") as XMLHttpRequest;
  }
}

export const getInput = (id: string): HTMLInputElement | null => {
  return document.getElementById(id) as HTMLInputElement | null;
}

export const createAxios = (domain: string) =>  axios.create({
  baseURL: domain,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

export const utf8Decode = (e: string): string => {
  let t = "", n = 0;
  while (n < e.length) {
    const r = e.charCodeAt(n);
    if (r < 128) {
      t += String.fromCharCode(r);
      n++;
    } else if (r > 191 && r < 224) {
      const c2 = e.charCodeAt(n + 1);
      t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
      n += 2;
    } else {
      const c2 = e.charCodeAt(n + 1);
      const c3 = e.charCodeAt(n + 2);
      t += String.fromCharCode(((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
      n += 3;
    }
  }
  return t;
};

export const utf8Encode = (e: string): string => {
  e = e.replace(/\r\n/g, "\n");
  let t = "";
  for (let n = 0; n < e.length; n++) {
    const r = e.charCodeAt(n);
    if (r < 128) t += String.fromCharCode(r);
    else if (r < 2048) {
      t += String.fromCharCode((r >> 6) | 192);
      t += String.fromCharCode((r & 63) | 128);
    } else {
      t += String.fromCharCode((r >> 12) | 224);
      t += String.fromCharCode(((r >> 6) & 63) | 128);
      t += String.fromCharCode((r & 63) | 128);
    }
  }
  return t;
}

export const base64Encode = (e: string): string => {
  let t = "", n: number, r: number, i: number, s: number, o: number, u: number, a: number, f = 0;
  e = utf8Encode(e);
  while (f < e.length) {
    n = e.charCodeAt(f++);
    r = e.charCodeAt(f++);
    i = e.charCodeAt(f++);
    s = n >> 2;
    o = ((n & 3) << 4) | (r >> 4);
    u = ((r & 15) << 2) | (i >> 6);
    a = i & 63;
    if (isNaN(r)) {
      u = a = 64;
    } else if (isNaN(i)) {
      a = 64;
    }
    t += KEY_STRING.charAt(s) + KEY_STRING.charAt(o) +
      KEY_STRING.charAt(u) + KEY_STRING.charAt(a);
  }
  return t;
};

export const base64Decode = (e: string): string => {
  let t = "", n: number, r: number, i: number, s: number, o: number, u: number, a: number, f = 0;
  e = e.replace(/[^A-Za-z0-9+/=]/g, "");
  while (f < e.length) {
    s = KEY_STRING.indexOf(e.charAt(f++));
    o = KEY_STRING.indexOf(e.charAt(f++));
    u = KEY_STRING.indexOf(e.charAt(f++));
    a = KEY_STRING.indexOf(e.charAt(f++));
    n = (s << 2) | (o >> 4);
    r = ((o & 15) << 4) | (u >> 2);
    i = ((u & 3) << 6) | a;
    t += String.fromCharCode(n);
    if (u != 64) t += String.fromCharCode(r);
    if (a != 64) t += String.fromCharCode(i);
  }
  return utf8Decode(t);
}

// Helper function to check and convert response to base64
export const convertResponseToBase64 = async (response: any): Promise<string> => {
  // Check if response data is a Blob
  if (response.data instanceof Blob) {
    return await blobToBase64(response.data);
  }

  // Check if response data is a File
  if (response.data instanceof File) {
    return await blobToBase64(response.data);
  }

  // Check if response is ArrayBuffer
  if (response.data instanceof ArrayBuffer) {
    const blob = new Blob([response.data]);
    return await blobToBase64(blob);
  }

  // Check if response headers indicate binary content
  const contentType = response.headers?.['content-type'] || '';
  if (contentType.includes('application/pdf') || contentType.includes('application/octet-stream')) {
    // Convert to blob first, then to base64
    const blob = new Blob([response.data], { type: contentType });
    return await blobToBase64(blob);
  }

  // If it's already a base64 string, return as is
  if (typeof response.data === 'string') {
    // Check if it's already base64 encoded
    try {
      atob(response.data);
      return response.data; // Already base64
    } catch (e) {
      // Not base64, convert string to base64
      return btoa(response.data);
    }
  }

  // For other data types, convert to JSON string then to base64
  return btoa(JSON.stringify(response.data));
};
